<ng-container [ngSwitch]="link?.type">
    <ng-container *ngSwitchCase="UmbracoMediaType.EmbeddedVideo">
        <figure ga4ViewPromotion
                [promotion_name]="link?.name ?? caption"
                [attr.title]="link?.name ?? caption"
                [attr.style]="'--backgroundImage:url('+link?.poster+');'"
                (click)="removePoster(id)">
            <iframe frameborder="0"
                    allow="accelerometer; fullscreen; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    [id]="id"
                    #iframe
                    [attr.poster]="!link['src'].includes('autoplay=1') && link?.poster?.length > 0 ? '' : null"
                    [attr.height]="iframe.clientWidth"
                    [attr.aspect-ratio]="settings?.aspectRatio"
                    ga4ViewPromotion
                    loading="lazy"
                    [attr.src]="link['src'] | sanitizer:SafeValue.SafeResourceUrl">
            </iframe>
            <figcaption>
                <h1>{{caption}}</h1>
            </figcaption>
        </figure>
    </ng-container>
    <figure ga4ViewPromotion
            [promotion_name]="link?.name ?? caption"
            [attr.title]="link?.name ?? caption"
            *ngSwitchCase="UmbracoMediaType.Video">
        <video onplaying="this.parentElement.setAttribute('hide-icon','')"
               onpause="this.parentElement.removeAttribute('hide-icon')"
               onended="this.parentElement.removeAttribute('hide-icon')"
               [id]="id"
               [use]="link"></video>
        <div *ngSwitchDefault>Don't know how to handle {{ link | json }}</div>
        <figcaption>
            <h1>{{caption}}</h1>
        </figcaption>
    </figure>
</ng-container>
